module.exports = __webpack_public_path__ + "img/Frame_s15_b0_9x12_1_SSC_UK.1289f62a.png";